import Typography from '@mui/material/Typography'

import Wrapper from './Wrapper'

export const NotFound = () => (
  <Wrapper name="Not Found">
    <Typography>Sorry, the page you are looking for is not available.</Typography>
  </Wrapper>
)
